/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { store } from "@/main";
import { pathOr } from "ramda";
import { generateApiUrl, storeDispatcher } from "@/shared/utils";

export const getActiveRegistrations = async () => {
  try {
    const queryString = { company_code: process.env.VUE_APP_COMPANY_CODE };
    const url = generateApiUrl(
      ["pre_register", "active_registrations"],
      [],
      queryString
    );
    const response = await httpService.get(url);
    const activeRegistrations = pathOr([], ["data", "data"], response);
    return {
      activeRegistrations: activeRegistrations.map((item) => {
        return {
          caption: pathOr("", ["link_caption"], item),
          code: pathOr(null, ["code"], item),
          registerCondition: pathOr("", ["register_condition"], item),
          gregorianStartDate: pathOr(null, ["start_date", "gregorian"], item),
          jalaliStartDate: pathOr(null, ["start_date", "jalali"], item),
        };
      }),
    };
  } catch (error) {
    throw error;
  }
};
export const getDetailRegistrations = async (code) => {
  try {
    const url = generateApiUrl(["pre_register", "detail_registration"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    await store.dispatch("auth/setAction", {
      key: "currentCourse",
      value: data,
    });

    return {
      code: pathOr(null, ["code"], data),
      linkCaption: pathOr(null, ["link_caption"], data),
      linkRegisterCondition: pathOr(null, ["link_register_condition"], data),
    };
  } catch (error) {
    throw error;
  }
};
export const sendMobile = async (code, mobile, captcha, key) => {
  try {
    const url = generateApiUrl(["pre_register", "send_mobile"]);
    const payload = {
      code,
      mobile,
      captcha,
      key,
    };
    const response = await httpService.put(url, payload);
    const data = pathOr(null, ["data", "data"], response);
    const preRegisterCode = pathOr(null, ["pre_register_code"], data);
    await store.dispatch("auth/setAction", {
      key: "preRegisterCode",
      value: preRegisterCode,
    });
    await storeDispatcher("preRegisterUsername", mobile, "auth");
    return {
      resExpireSeconds: pathOr(300, ["expire_seconds"], data),
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
export const resetData = async () => {
  await storeDispatcher("currentCourse", null, "auth");
  await storeDispatcher("preRegisterCode", null, "auth");
  await storeDispatcher("hasNationalCode", false, "auth");
  await storeDispatcher("nationalCodePreview", null, "auth");
  await storeDispatcher("parvandehInfo", null, "auth");
};
export const confirmMobile = async (code) => {
  try {
    const url = generateApiUrl(["pre_register", "confirm_mobile"]);
    const payload = {
      otp_code: code,
      pre_register_code: pathOr(null, ["auth", "preRegisterCode"], store.state),
    };
    const response = await httpService.patch(url, payload);

    const data = pathOr(null, ["data", "data"], response);
    const preRegisterCode = pathOr(null, ["pre_register_code"], data);
    const hasNationalCode = pathOr(false, ["has_national_code"], data);
    const extraFields = pathOr(null, ["extra_fields"], data);
    const parvandehInfo = pathOr(null, ["parvandeh_info"], data);
    const registerStatus = pathOr(null, ["register_status"], data);
    const dynamicFieldCaption = pathOr(null, ["register_code_caption"], data);

    await storeDispatcher("preRegisterCode", preRegisterCode, "auth");
    await storeDispatcher("hasNationalCode", hasNationalCode, "auth");
    await storeDispatcher("extraFields", extraFields, "auth");

    // guidance: if status is register_done => successfully and completed register
    if (registerStatus === "register_done") {
      await resetData();
      await storeDispatcher("parvandehInfo", parvandehInfo, "auth");
    }

    //guidance: if status is register_without_code => get all enumerations for use in identity form
    if (registerStatus === "register_without_code") {
      await store.dispatch("getAllEnumeration");
    }

    return {
      registerStatus,
      dynamicFieldCaption,
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
export const confirmRegistrationCode = async (
  nationalCode,
  dynamicCode,
  captcha,
  key
) => {
  try {
    const url = generateApiUrl(["pre_register", "confirm_registration_code"]);
    const payload = {
      national_code: nationalCode,
      code: dynamicCode,
      captcha,
      key,
      pre_register_code: pathOr(null, ["auth", "preRegisterCode"], store.state),
    };
    const response = await httpService.put(url, payload);

    const data = pathOr(null, ["data", "data"], response);
    const preRegisterCode = pathOr(null, ["pre_register_code"], data);
    const nationalCodePreview = pathOr(null, ["national_code"], payload);
    const parvandehInfo = pathOr(null, ["parvandeh_info"], data);
    const registerStatus = pathOr(null, ["register_status"], data);

    await storeDispatcher("preRegisterCode", preRegisterCode, "auth");
    await storeDispatcher("nationalCodePreview", nationalCodePreview, "auth");

    // guidance: if status is register_done => successfully and completed register
    if (registerStatus === "register_done") {
      await storeDispatcher("parvandehInfo", parvandehInfo, "auth");
    }

    //guidance: if status is register_code_confirmed => get all enumerations for use in identity form
    if (registerStatus === "register_code_confirmed") {
      await store.dispatch("getAllEnumeration");
    }

    return {
      registerStatus,
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
export const setPreRegister = async ({
  password,
  nationalCode,
  name,
  family,
  birthDate,
  educationGrade,
  sokonatCity,
  jobLevel,
  jobCategory,
  gender,
}) => {
  try {
    const url = generateApiUrl(["pre_register", "pre_register"]);
    const payload = {
      password,
      national_code: nationalCode,
      name,
      family,
      birth_date: birthDate,
      education_grade_id: educationGrade,
      location_id: sokonatCity,
      job_level_id: jobLevel,
      job_category: jobCategory,
      gender_id: gender,
      pre_register_code: pathOr(null, ["auth", "preRegisterCode"], store.state),
      grant_type: "password",
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      scope: "*",
    };
    const response = await httpService.post(url, payload);

    const data = pathOr(null, ["data", "data"], response);
    const auth = pathOr(null, ["auth"], data);
    const activeParvandeh = pathOr(null, ["auth", "current_parvandeh"], data);
    const resourceName = pathOr(null, ["resource"], data);
    const resourceValue = pathOr(null, ["resource_id"], data);
    const accessToken = pathOr(null, ["access_token"], auth);
    const routeName = pathOr("dashboard", ["route_name"], data);

    // set parvandeh information for use in result page
    await storeDispatcher("parvandehInfo", data, "auth");

    if (accessToken) {
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("afterLoginRoute", routeName);
      localStorage.setItem("activeParvandeh", JSON.stringify(activeParvandeh));

      // get all enumeration when logged in
      await store.dispatch("getAllEnumeration");
    }

    return {
      action: accessToken ? "LOGGED_IN" : "SHOW_RESULT",
      routeName,
      resourceName,
      resourceValue,
      message: pathOr(null, ["data", "message"], response),
    };
  } catch (error) {
    throw error;
  }
};
